module.exports = __webpack_public_path__ + "img/hotstyleshow2.6deb882c.jpg";